import React, { FC, useCallback, useState } from 'react';
import { useFeatureRoles } from 'src/models/users/Roles/hooks';
import { useMutation } from '@apollo/client';
import { UPDATE_COMPANY_FEATURE_ROLE } from 'src/models/admin/CompanyUsers/queries';
import { IApiCompany } from 'src/models/company/types';
import { useTranslation } from 'react-i18next';
import { Button, confirm, notification, Select } from 'src/common';
import styles from './index.module.scss';
import modalStyles from 'src/common/Modal/index.module.scss';
import { FeatureRole } from '@tendium/prom-types';

interface FeatureRoleSelectProps {
  companyId: string;
  featureRoles: FeatureRole[];
}
// FIXME: @ fix feature role select
export const FeatureRoleSelect: FC<FeatureRoleSelectProps> = props => {
  const { featureRoles, companyId } = props;
  const { t } = useTranslation();
  const [chosenFeatureRoles, setChosenFeatureRoles] = useState(featureRoles);
  const availableFeatureRoles = useFeatureRoles();

  const [updateCompanyFeatureRole] = useMutation<
    { updateCompanyFeatureRole: IApiCompany },
    { companyId: string; featureRoles: FeatureRole[] }
  >(UPDATE_COMPANY_FEATURE_ROLE);

  const updateFeatureRoles = useCallback(
    (featuresRoles: FeatureRole[]) => {
      confirm.confirm({
        title: t('AdminPage.confirmTitle'),
        okText: t('Common.yes'),
        cancelText: t('Common.no'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          updateCompanyFeatureRole({ variables: { companyId, featureRoles: featuresRoles } })
            .then(r => {
              setChosenFeatureRoles(r.data?.updateCompanyFeatureRole?.featureRoles as FeatureRole[]);
            })
            .catch(() => {
              notification.error({
                message: t('Common.unknownError'),
                description: t('Common.unknownErrorDesc')
              });
            });
        }
      });
    },
    [companyId, t, updateCompanyFeatureRole]
  );

  const selectFeatureRole = useCallback(
    role => {
      if (chosenFeatureRoles) setChosenFeatureRoles([...chosenFeatureRoles, role]);
      else setChosenFeatureRoles([role]);
    },
    [chosenFeatureRoles]
  );

  const deselectFeatureRole = useCallback(
    (value: FeatureRole) => {
      updateFeatureRoles(chosenFeatureRoles.filter(v => v !== value));
    },
    [chosenFeatureRoles, updateFeatureRoles]
  );

  return (
    <Select
      style={{ width: '100%' }}
      mode={'multiple'}
      value={chosenFeatureRoles}
      onSelect={selectFeatureRole}
      onDeselect={deselectFeatureRole}
      size={'small'}
      dropdownRender={menu => (
        <>
          {menu}
          <div className={styles.btnContainer}>
            <Button type={'primary'} onClick={() => updateFeatureRoles(chosenFeatureRoles)} className={styles.saveBtn}>
              {t('Common.save')}
            </Button>
          </div>
        </>
      )}
    >
      {availableFeatureRoles.map(val => (
        <Select.Option value={val} key={val}>
          {val}
        </Select.Option>
      ))}
    </Select>
  );
};
